import {
  updateAxesQueryParam,
  toggleAxesEdited,
  setSelectedTableInTile,
} from '../../../../redux/ChartPoperties/ChartPropertiesActions';
import { saveNewCalculation } from '../../../../redux/Calculations/CalculationsActions';
import {
  updateChartFilterField,
  chartFilterGroupEdited,
} from '../../../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { findNewDisplayName } from '../../../CommonFunctions/CommonFunctions';
import { setDisplayName } from '../../../ChartAxes/setDisplayName';
import { setPrefix } from '../../../ChartAxes/SetPrefix';
import ChartsInfo from '../../../ChartAxes/ChartsInfo2';
import {
  callQueryAPI,
  updateFormatOption,
} from '../../../../redux/ChartPoperties/ChartControlsActions';
import { IFlows } from '../../../../redux/Calculations/CurrentCalculationSessionInterface';

export const updateStateAfterSuccessfulSave = (
  tableInfo: any,
  datasetId: string,
  calcInfo: any,
  session: any,
  chartProperties: any,
  chartGroup: any,
  propKey: string,
  dispatch: any,
  uuid: string,
  calculationReturnType: string,
  tableChange: boolean,
  oldTableId: string,
  chartControls: any /**needed to update tooltip extra measure format */,
  orderedListOfFlows: string[],
  oldCalcName?: string,
) => {
  dispatch(
    setSelectedTableInTile(propKey, {
      [datasetId]: tableInfo.id,
    }),
  );

  if (tableChange) {
    let sampleRecordsData = sessionStorage.getItem('sampleRecords');
    let sampleRecords = sampleRecordsData ? JSON.parse(sampleRecordsData) : {};
    let sampleRecordsTableData = sampleRecords?.[datasetId]?.[oldTableId];
    let sampleRecordsColumnType = sampleRecords?.['recordsColumnType']?.[datasetId]?.[oldTableId];

    sampleRecordsTableData.forEach((record: any) => {
      oldCalcName && delete record[oldCalcName];
    });
    sampleRecordsColumnType = sampleRecordsColumnType.filter((item: any) => {
      return item.columnName !== oldCalcName;
    });

    let newSampleRecords = {
      ...sampleRecords,
      [datasetId]: {
        ...sampleRecords[datasetId],
        [oldTableId]: sampleRecordsTableData,
      },
      recordsColumnType: {
        ...sampleRecords.recordsColumnType,
        [datasetId]: {
          ...(sampleRecords.recordsColumnType[datasetId] || {}),
          [oldTableId]: sampleRecordsColumnType,
        },
      },
    };

    sessionStorage.setItem('sampleRecords', JSON.stringify(newSampleRecords));
  }

  const allPropKeys = Object.keys(chartProperties.properties);
  const allGroupKeys = Object.keys(chartGroup.groups);
  const apiCalledTriggeredForPropKey: string[] = [];
  const updateGroupMap: any = {};

  for (const eachPropKey of allPropKeys) {
    /**
     *
     *
     * we have to update the override part, its not good idea to update  root axis  trigger api call and tyhen  update override part then api call
     *
     * so approach will be  if  we found currentCalculation as a field  of root/base measure we will; update the root measure field with latest calc info
     * now we will check if that measure field   has override  or not if it has override  iterate over all override and check if any  override axis has  current caclulation as field if it has then update
     *
     * so as of now  we can ensure that if current calculation  is found in root/base measure it will be updated and if that field has override its  override will be updated if it has current calculation in override axis
     *
     *
     * no we have to check for not calculated field in root measure  taht has override
     *
     */
    let ignorredNames: string[] = [];
    const chartType = chartProperties?.properties[eachPropKey]?.chartType;
    let didUpdate = false;
    let calcHasWindowFn = false;
    let calcHasOverride = false;
    Object.values(calcInfo.flows as IFlows).some((steps) =>
      steps.some((step) => {
        if (!step.flowOverride) {
          calcHasOverride = false;
        } else if (
          step.flowOverride.dimension.type !== 'honorAll' ||
          step.flowOverride.filter.type !== 'honorAll'
        ) {
          calcHasOverride = true;
        } else {
          calcHasOverride = false;
        }
        if (step.flowOverride?.windowFunction) {
          calcHasWindowFn = true;
        }

        if (calcHasWindowFn && calcHasOverride) return true;
        return false;
      }),
    );
    chartProperties?.properties[eachPropKey]?.chartAxes.forEach((ax: any, axId: number) => {
      ax?.fields?.forEach((field: any, fieldId: number) => {
        if (field.SavedCalculationUUID === session.uuid) {
          didUpdate = true;
          dispatch(toggleAxesEdited(eachPropKey, true));
          dispatch(chartFilterGroupEdited(true));

          const newFieldData = setDisplayName(
            setPrefix(
              {
                ...field,
                fieldname: calcInfo.calculatedFieldName,
                displayname: field.isTextRenamed ? field.displayname : calcInfo.calculatedFieldName,
              },
              ax.name,
              chartType,
            ),
            ax.name,
            chartType,
          );
          if (field.windowfn && (calcHasWindowFn || calcHasOverride)) newFieldData.windowfn = null;
          if (!field.isTextRenamed && field.fieldname !== calcInfo.calculatedFieldName) {
            newFieldData.displayname = findNewDisplayName(
              chartProperties?.properties[eachPropKey]?.chartAxes,
              newFieldData,
              chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
              ignorredNames,
            );
            if (!ignorredNames.includes(newFieldData.displayname))
              ignorredNames.push(newFieldData.displayname);
          }

          if (!(calcHasWindowFn || calcHasOverride) && field.override) {
            const overrideAxesInfo = field.override;

            const newOverride = overrideAxesInfo.map((overrideAxis: any) => {
              return {
                ...overrideAxis,
                fields: overrideAxis.fields.map((_field: any) => {
                  if (_field.SavedCalculationUUID === session.uuid) {
                    const updatedOverrideInfo = setDisplayName(
                      setPrefix(
                        {
                          ..._field,
                          fieldname: calcInfo.calculatedFieldName,
                          displayname: _field.isTextRenamed
                            ? _field.displayname
                            : calcInfo.calculatedFieldName,
                        },
                        ax.name,
                        chartType,
                      ),
                      ax.name,
                      chartType,
                    );
                    if (
                      !_field.isTextRenamed &&
                      _field.fieldname !== calcInfo.calculatedFieldName
                    ) {
                      updatedOverrideInfo.displayname = findNewDisplayName(
                        chartProperties?.properties[eachPropKey]?.chartAxes,
                        updatedOverrideInfo,
                        chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
                        ignorredNames,
                      );
                      if (!ignorredNames.includes(updatedOverrideInfo.displayname))
                        ignorredNames.push(updatedOverrideInfo.displayname);
                    }
                    return {
                      ...updatedOverrideInfo,
                      fieldname: calcInfo.calculatedFieldName,
                      dataType: calculationReturnType,
                      tableId: tableInfo.id,
                      isCalculatedField: true,
                      uId: _field.uId,
                      agg: _field.agg,
                      SavedCalculationUUID: session.uuid || null,
                      isAggregated: false,
                      hasOverridedFlow:
                        calcInfo.overrideCount > 0 ,
                    };
                  }
                  return _field;
                }),
              };
            });
            newFieldData.override = newOverride;
          }
          if (field.override && calcHasOverride) newFieldData.override = null;
          dispatch(
            updateAxesQueryParam(
              eachPropKey,
              axId,
              fieldId,
              {
                ...newFieldData,
                dataType: calculationReturnType,
                tableId: tableInfo.id,
                uId: field.uId,
                agg: field.agg,
                displayname: field.isTextRenamed ? field.displayname : newFieldData.displayname,
                SavedCalculationUUID: session.uuid || null,
                isTextRenamed: field.isTextRenamed ?? false,
              },
              'chartAxes',
            ),
          );
        } else if (field.override) {
          const overrideAxesInfo = field.override;
          let newOverride = null;
          if (!calcHasOverride) {
            newOverride = overrideAxesInfo.map((overrideAxis: any) => {
              return {
                ...overrideAxis,
                fields: overrideAxis.fields.map((_field: any) => {
                  if (_field.SavedCalculationUUID === session.uuid) {
                    didUpdate = true;
                    const updatedOverrideInfo = setDisplayName(
                      setPrefix(
                        {
                          ..._field,
                          fieldname: calcInfo.calculatedFieldName,
                          displayname: _field.isTextRenamed
                            ? _field.displayname
                            : calcInfo.calculatedFieldName,
                        },
                        ax.name,
                        chartType,
                      ),
                      ax.name,
                      chartType,
                    );
                    if (
                      !_field.isTextRenamed &&
                      _field.fieldname !== calcInfo.calculatedFieldName
                    ) {
                      updatedOverrideInfo.displayname = findNewDisplayName(
                        chartProperties?.properties[eachPropKey]?.chartAxes,
                        updatedOverrideInfo,
                        chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
                        ignorredNames,
                      );
                      if (!ignorredNames.includes(updatedOverrideInfo.displayname))
                        ignorredNames.push(updatedOverrideInfo.displayname);
                    }
                    return {
                      ...updatedOverrideInfo,
                      fieldname: calcInfo.calculatedFieldName,
                      dataType: calculationReturnType,
                      tableId: tableInfo.id,
                      isCalculatedField: true,
                      uId: _field.uId,
                      agg: _field.agg,
                      SavedCalculationUUID: session.uuid || null,
                      isAggregated: false,
                      hasOverridedFlow:
                        calcInfo.overrideCount > 0 ,
                    };
                  }
                  return _field;
                }),
              };
            });
          }
          dispatch(
            updateAxesQueryParam(
              eachPropKey,
              axId,
              fieldId,
              {
                ...field,
                override: newOverride,
              },
              'chartAxes',
            ),
          );
          // dispatch(callQueryAPI(eachPropKey, true));
        }
      });
    });

    if (didUpdate) {
      if (!apiCalledTriggeredForPropKey.includes(eachPropKey)) {
        apiCalledTriggeredForPropKey.push(eachPropKey);
        dispatch(callQueryAPI(eachPropKey, true));
      }
    }

    /****************************************
     ***UPDATE TOOLTIP EXTRA MEASURE**
     ****************************************/

    /** extraMeasureField willl be always be array of 1 element  */
    const extraMeasureFields =
      chartControls?.properties[eachPropKey]?.formatOptions?.tooltipFormats?.extraMeasureField;
    if (!extraMeasureFields) continue;
    const fields = extraMeasureFields[0].fields; // 0 index to get the first element
    if (!fields) continue;
    let updated = false;
    const newFields = fields.map((field: any) => {
      if (field.SavedCalculationUUID === session.uuid) {
        updated = true;
        const newFieldData = setDisplayName(
          setPrefix(
            {
              ...field,
              fieldname: calcInfo.calculatedFieldName,
              displayname: field.isTextRenamed ? field.displayname : calcInfo.calculatedFieldName,
            },
            'Measure',
            chartType,
          ),
          'Measure',
          chartType,
        );
        if (calcHasWindowFn || calcHasOverride) newFieldData.windowfn = null;
        if (!field.isTextRenamed && field.fieldname !== calcInfo.calculatedFieldName) {
          newFieldData.displayname = findNewDisplayName(
            chartProperties?.properties[eachPropKey]?.chartAxes,
            newFieldData,
            chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
            ignorredNames,
          );
          if (!ignorredNames.includes(newFieldData.displayname))
            ignorredNames.push(newFieldData.displayname);
        }
        if (field.override) {
          const overrideAxesInfo = field.override;
          let newOverride = null;
          if (!(calcHasWindowFn || calcHasOverride)) {
            newOverride = overrideAxesInfo.map((overrideAxis: any) => {
              return {
                ...overrideAxis,
                fields: overrideAxis.fields.map((_field: any) => {
                  if (_field.SavedCalculationUUID === session.uuid) {
                    const updatedOverrideInfo = setDisplayName(
                      setPrefix(
                        {
                          ..._field,
                          fieldname: calcInfo.calculatedFieldName,
                          displayname: _field.isTextRenamed
                            ? _field.displayname
                            : calcInfo.calculatedFieldName,
                        },
                        overrideAxis.name,
                        chartType,
                      ),
                      overrideAxis.name,
                      chartType,
                    );
                    if (
                      !_field.isTextRenamed &&
                      _field.fieldname !== calcInfo.calculatedFieldName
                    ) {
                      updatedOverrideInfo.displayname = findNewDisplayName(
                        chartProperties?.properties[eachPropKey]?.chartAxes,
                        updatedOverrideInfo,
                        chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
                        ignorredNames,
                      );
                      if (!ignorredNames.includes(updatedOverrideInfo.displayname))
                        ignorredNames.push(updatedOverrideInfo.displayname);
                    }
                    return {
                      ..._field,
                      fieldname: calcInfo.calculatedFieldName,
                      dataType: calculationReturnType,
                      tableId: tableInfo.id,
                      isCalculatedField: true,
                      uId: _field.uId,
                      agg: _field.agg,
                      SavedCalculationUUID: session.uuid || null,
                      isAggregated: false,
                      hasOverridedFlow:
                        calcInfo.overrideCount > 0 ,
                    };
                  }
                  return _field;
                }),
              };
            });
          }
          newFieldData.override = newOverride;
        }
        return {
          ...newFieldData,
          dataType: calculationReturnType,
          tableId: tableInfo.id,
          uId: field.uId,
          agg: field.agg,
          displayname: field.isTextRenamed ? field.displayname : newFieldData.displayname,
          SavedCalculationUUID: session.uuid || null,
          isTextRenamed: field.isTextRenamed ?? false,
          isCalculatedField: true,
          isAggregated: false,
          hasOverridedFlow: calcInfo.overrideCount > 0 ,
        };
      }

      if (field.override) {
        const overrideAxesInfo = field.override;
        let newOverride = null;
        if (!(calcHasWindowFn || calcHasOverride)) {
          newOverride = overrideAxesInfo.map((overrideAxis: any) => {
            return {
              ...overrideAxis,
              fields: overrideAxis.fields.map((_field: any) => {
                if (_field.SavedCalculationUUID === session.uuid) {
                  updated = true;
                  const updatedOverrideInfo = setDisplayName(
                    setPrefix(
                      {
                        ..._field,
                        fieldname: calcInfo.calculatedFieldName,
                        displayname: _field.isTextRenamed
                          ? _field.displayname
                          : calcInfo.calculatedFieldName,
                      },
                      overrideAxis.name,
                      chartType,
                    ),
                    overrideAxis.name,
                    chartType,
                  );
                  if (!_field.isTextRenamed && _field.fieldname !== calcInfo.calculatedFieldName) {
                    updatedOverrideInfo.displayname = findNewDisplayName(
                      chartProperties?.properties[eachPropKey]?.chartAxes,
                      updatedOverrideInfo,
                      chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
                      ignorredNames,
                    );
                    if (!ignorredNames.includes(updatedOverrideInfo.displayname))
                      ignorredNames.push(updatedOverrideInfo.displayname);
                  }
                  return {
                    ..._field,
                    fieldname: calcInfo.calculatedFieldName,
                    dataType: calculationReturnType,
                    tableId: tableInfo.id,
                    isCalculatedField: true,
                    uId: _field.uId,
                    agg: _field.agg,
                    SavedCalculationUUID: session.uuid || null,
                    isAggregated: false,
                    hasOverridedFlow:
                      calcInfo.overrideCount > 0,
                  };
                }
                return _field;
              }),
            };
          });
        }

        field.override = newOverride;
        return {
          ...field,
          override: newOverride,
        };
      } else return field;
    });
    if (updated) {
      extraMeasureFields[0].fields = newFields;
      dispatch(
        updateFormatOption(eachPropKey, 'tooltipFormats', 'extraMeasureField', extraMeasureFields),
      );
      if (!apiCalledTriggeredForPropKey.includes(eachPropKey)) {
        apiCalledTriggeredForPropKey.push(eachPropKey);
        dispatch(callQueryAPI(eachPropKey, true));
      }
    }
  }

  dispatch(
    saveNewCalculation(
      propKey,
      session.uuid || uuid,
      false,
      calculationReturnType,
      orderedListOfFlows,
    ),
  );

  for (const key of allGroupKeys) {
    chartGroup.groups[key].filters.forEach((filter: any, filterId: number) => {
      if (filter.SavedCalculationUUID === session.uuid) {
        updateGroupMap[key] = {
          filterIndex: filterId,
          fieldname: calcInfo.calculatedFieldName || '',
          displayname: calcInfo.calculatedFieldName || '',
          tableId: tableInfo.id,
        };
      }
    });
  }
  const APICallNeededForTiles: string[] = [];
  for (const groupKey in updateGroupMap) {
    const update = updateGroupMap[groupKey];
    dispatch(
      updateChartFilterField(groupKey, update.filterIndex, {
        fieldname: update.fieldname,
        displayname: update.displayname,
        displayName2: update.displayname,
        tableId: update.tableId,
      }),
    );
    const tilesAttachedToFilterGroup = Object.keys(chartGroup.tabTile).filter((propKey) =>
      chartGroup.tabTile[propKey].includes(groupKey),
    );
    APICallNeededForTiles.push(...tilesAttachedToFilterGroup);
  }
  APICallNeededForTiles.forEach((propKey) => {
    if (!apiCalledTriggeredForPropKey.includes(propKey)) {
      apiCalledTriggeredForPropKey.push(propKey);
      dispatch(callQueryAPI(propKey, true));
    }
  });
};
